export const MIN_NIGHTS = 1;
export const MAX_NIGHTS = 29;
